export const GET_INFO = 'GET_INFO';
export const GET_QUOTE = 'GET_QUOTE';
export const GET_SKILLS = 'GET_SKILLS';
export const GET_PROJECTS = 'GET_PROJECTS';
export const GET_CONTACT = 'GET_CONTACT';
export const GET_RANDOM_QUOTE = 'GET_RANDOM_QUOTE';
export const ALL_QUOTES = 'ALL_QUOTES';
export const SCROLL_OUT_BANNER = 'SCROLL_OUT_BANNER';
export const SCROLL_IN_BANNER = 'SCROLL_IN_BANNER';
